import { render, staticRenderFns } from "./testSvg.vue?vue&type=template&id=1e00aa45&scoped=true"
import script from "./testSvg.vue?vue&type=script&lang=js"
export * from "./testSvg.vue?vue&type=script&lang=js"
import style0 from "./testSvg.vue?vue&type=style&index=0&id=1e00aa45&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e00aa45",
  null
  
)

export default component.exports